import {createReducer} from "./index";
import * as R from 'ramda';
import {ADD_TASKS} from "../actions/tasks";

/*
Structure of tasks model:

{
  data: {
    [uuid]: {
      permissions: {
        // these are returned by the backend; may not be up to date
        view: bool
        update: bool
        delete: bool
      }
      resource: {
        // these are returned by the backend; may not be up to date
        id: string // uuid
        projectid: string // uuid
        name: string
        description: string
        status: string // code-drive code_taskstatus
        owneruserid: string // uuid
        createdbyuserid: string // uuid
        active: bool
        createdbycompanyid: string // uuid
        ownercompanyid: string // uuid
        priority: string // code-driven code_taskpriority
        duedate: date
        number: string
        datecreated: datetime
        abbreviation: string
      }
    }
  }
  indexes: {
    // used for indexing entries by different fields other than the id field
    projectid: {
      [projectid]:
        [submittalid]: dontcare
    }
  }

}
 */

const tasksInitial = {
  data: {},
  indexes: {
    projectid: {}
  },
};

const tasksReducer = createReducer(tasksInitial,
  {
    [ADD_TASKS]: (state, action) => {
      let newState = state;
      action.payload.forEach(item => {
        newState = R.over(R.lensPath(['data', item.resource.id]), () => item)(newState);
        newState = R.over(R.lensPath(['indexes', 'projectid', item.resource.projectid]), value => {
          if (!value) {
            return {[item.resource.id]: 1};
          } else {
            return {...value, [item.resource.id]: 1};
          }
        })(newState);
      });
      return newState;
    }

    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default tasksReducer;


// WEBPACK FOOTER //
// ./src/reducers/tasks.js